export default __webpack_public_path__ + "static/media/logo-anorthosis.6bfb62cf.svg";